module.exports = __webpack_public_path__ + "static/media/image_16.953707ee.png";